import { isString } from 'lodash';
import moment from 'moment';

import { fromAnyDateToZulu } from 'utils/converters/time/from.util';
import { formatYearToDayStandard } from 'utils/date/format.util';
import logger from 'utils/logger.util';
import parseIsoZulu from 'utils/parsers/parseIsoZulu.util';
import isValidDateMoment from 'utils/predicates/time/isValidDateMoment.util';
import isValidDateObject from 'utils/predicates/time/isValidDateObject.util';

const L = logger('combine');

const INTERMEDIARY_DATE_FORMAT = 'YYYY-MM-DD';
const INTERMEDIARY_FULL_FORMAT = `${INTERMEDIARY_DATE_FORMAT} hh:mm:ss A`;

export const combineDateTimeZulu = (options) => {
  const { date, time } = options ?? {};

  // first checks

  const zuluDate = fromAnyDateToZulu(date);
  if (!zuluDate) {
    L.warn('Invalid date:', date, 'returning empty string');
    return '';
  }

  const zuluTime = fromAnyDateToZulu(time);
  if (!zuluTime) {
    L.warn('Invalid time:', time, 'returning empty string');
    return '';
  }

  // then combine the first and second parts respectively

  return `${zuluDate.split('T')[0]}T${zuluTime.split('T')[1]}`;
};

export const combineDateTimeIso = (options) => {
  const { date, time } = options ?? {};

  // first checks

  const d = parseIsoZulu(date);
  if (!d.is.valid) {
    L.warn('Invalid date:', date, 'is:', d.is, 'returning empty string');
    return '';
  }

  const t = parseIsoZulu(time);
  if (!t.is.valid) {
    L.warn('Invalid time:', time, 'is:', t.is, 'returning empty string');
    return '';
  }

  return `${d.years}-${d.months}-${d.days}T${t.hours}:${t.minutes}:${t.seconds}.${t.milliseconds}${d.offset}`;
};

export const combineDateTimeZoneZulu = (date, time, tz) => {
  if (!isValidDateObject(date) && !isValidDateMoment(date) && !isString(date) && !Number.isSafeInteger(date)) {
    return '';
  }

  const datePart = moment(date).format(INTERMEDIARY_DATE_FORMAT);
  const combined = `${datePart} ${time}Z`;

  return moment.tz(combined, INTERMEDIARY_FULL_FORMAT, tz).toISOString() || '';
};

export const combineDateStartTime = (options) => {
  const date = formatYearToDayStandard(options?.date);
  const time = fromAnyDateToZulu(options?.time).split('T')[1];

  const combinedDateTime = `${date}T${time}`;
  if (moment(combinedDateTime).isValid()) return combinedDateTime;

  L.warn('combineDateStartTime()', 'Invalid combinedDateTime:', combinedDateTime, 'for options:', options);
  return '';
};
